import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(VueGtm, {
  id: 'GTM-TBXMGTB',
  enabled: process.env.NODE_ENV === 'production',
});
